import axios from 'axios';
import { setupCache } from 'axios-cache-adapter';
import { getUnreadMessages } from 'src/utils/messageUtils';

export const updateConversation = async (id, data) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/conversations/${id}`;

    return axios.put(ApiUrl, data).then((response) => response.data);
}

export const getConversation = async (params = "") => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/conversations${params}`;

        // Créer une instance de cache
        const cache = setupCache({
            maxAge: 60 * 60 * 1000,
            debug: false
        });
      
        // Créer une instance d'Axios avec le cache
        const api = axios.create({
            adapter: cache.adapter
        });

    return api.get(ApiUrl).then((response) => response.data);
}

export const getConversationUnread = async (customerId) => {
    const ApiUrl = `${process.env.REACT_APP_PUBLIC_API}/conversations?annonce.customer=${customerId}`;

        // Créer une instance de cache
        const cache = setupCache({
            maxAge: 60 * 60 * 1000,
            debug: false
        });
      
        // Créer une instance d'Axios avec le cache
        const api = axios.create({
            adapter: cache.adapter
        });

    return api.get(ApiUrl).then((response) => {
        
        // Filtrer les conversations (même logique que Messages.js)
        let data = response.data.filter((conv) => {
            if (conv.annonce.status === "RESTITUÉ" || conv.annonce.status === "ENVOYÉ") {
                return false
            }
            return true
        });
        
        
        // Compter tous les messages non lus de toutes les conversations filtrées
        const allUnreadMessages = [];
        
        data.forEach((conversation, index) => {
            
            // Compter tous les messages non lus de cette conversation
            const unreadMessages = getUnreadMessages(conversation.messages || []);
            
            if (unreadMessages.length > 0) {
                allUnreadMessages.push(...unreadMessages);
            }
        });
        
        
        return allUnreadMessages;
    }).catch(error => {
        console.error('❌ Erreur dans getConversationUnread:', error);
        return [];
    });
}